import { createSelector } from 'reselect';
import { decode } from 'utils/crypto/crypto';

export const topUpSelector = (state: any) => state.topup;

export const topUpValueSelector = createSelector(topUpSelector, (topup) => topup?.topupValue);

export const selectedNumbersSelector = createSelector(topUpSelector, (topup) =>
	topup?.selectedNumbers.map((number: any) =>
		Object.keys(number).reduce((acc, key) => ({ ...acc, [key]: decode(number[key]) }), {})
	)
);
